import { type ChatEngine } from '@littlebird/sdk';
import { makeAutoObservable } from 'mobx';
import { makePersistable } from 'mobx-persist-store';

/**
 * Engine per chat, keyed by thread ID, or by the composer draft ID before New
 * Chat's first send. A missing key runs the chat on `v4`. Only an unsent New
 * Chat can pick one, so a chat keeps its engine for every follow-up. Kept
 * apart from `chatStore` so `sdk-init` can read it without an import cycle
 */
class ChatEngineStore {
  engineByChat: Record<string, ChatEngine> = {};

  constructor() {
    makeAutoObservable(this);
    void makePersistable(this, {
      name: 'chatEngineStore',
      properties: ['engineByChat'],
      storage: window.localStorage,
    });
  }

  set(chatKey: string, engine: ChatEngine) {
    this.engineByChat = { ...this.engineByChat, [chatKey]: engine };
  }

  move(fromKey: string, toKey: string) {
    const { [fromKey]: engine, ...rest } = this.engineByChat;
    if (engine === undefined) return;
    this.engineByChat = { ...rest, [toKey]: engine };
  }
}

export const chatEngineStore = new ChatEngineStore();
